// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");

function panic(msg) {
  return Common.panic("MM_wrk_sort_asrts: " + msg);
}

function sortByToStr(sortBy) {
  switch (sortBy) {
    case "UsageCnt" :
        return "UsageCnt";
    case "AsrtLen" :
        return "AsrtLen";
    case "AsrtLabel" :
        return "AsrtLabel";
    case "NumOfHyps" :
        return "NumOfHyps";
    
  }
}

var allSortByOptions = [
  [
    "UsageCnt",
    "UsageCnt",
    "Usage count"
  ],
  [
    "AsrtLen",
    "AsrtLen",
    "Length of the assertion"
  ],
  [
    "AsrtLabel",
    "AsrtLabel",
    "Label"
  ],
  [
    "NumOfHyps",
    "NumOfHyps",
    "Number of hypotheses"
  ]
];

function sortByFromStr(str) {
  var match = allSortByOptions.find(function (param) {
        return param[1] === str;
      });
  if (match !== undefined) {
    return match[0];
  } else {
    return panic("Cannot convert the value of '" + str + "' to a sortBy.");
  }
}

function sortByGetTitle(sortBy) {
  var match = allSortByOptions.find(function (param) {
        return param[0] === sortBy;
      });
  if (match !== undefined) {
    return match[2];
  } else {
    return panic("Cannot find the title for the sortBy '" + sortByToStr(sortBy) + "'.");
  }
}

function sortDirToStr(sortDir) {
  if (sortDir === "Asc") {
    return "ASC";
  } else {
    return "DESC";
  }
}

var allSortDirOptions = [
  [
    "Asc",
    "ASC",
    "Ascending"
  ],
  [
    "Dsc",
    "DESC",
    "Descending"
  ]
];

function sortDirFromStr(str) {
  var match = allSortDirOptions.find(function (param) {
        return param[1] === str;
      });
  if (match !== undefined) {
    return match[0];
  } else {
    return panic("Cannot convert the value of '" + str + "' to a sortDir.");
  }
}

function makeComparator(sortBys) {
  if (sortBys.length === 0) {
    return function (param, param$1) {
      return 0;
    };
  }
  var cmps = sortBys.map(function (param) {
        var sortBy = param[0];
        var sortDir = param[1];
        var cmp;
        switch (sortBy) {
          case "UsageCnt" :
              cmp = Expln_utils_common.comparatorByInt(function (frm) {
                    return frm.usageCnt;
                  });
              break;
          case "AsrtLen" :
              cmp = Expln_utils_common.comparatorByInt(function (frm) {
                    return frm.asrt.length;
                  });
              break;
          case "AsrtLabel" :
              cmp = Expln_utils_common.comparatorByStr(function (frm) {
                    return frm.label;
                  });
              break;
          case "NumOfHyps" :
              cmp = Expln_utils_common.comparatorByInt(function (frm) {
                    return frm.hyps.length - frm.varHyps.length | 0;
                  });
              break;
          
        }
        if (sortDir === "Asc") {
          return cmp;
        } else {
          return Expln_utils_common.cmpRev(cmp);
        }
      });
  if (cmps.length === 1) {
    return cmps[0];
  } else {
    return Core__Array.reduceWithIndex(cmps, cmps[0], (function (acc, cmp, idx) {
                  if (idx === 0) {
                    return acc;
                  } else {
                    return Expln_utils_common.comparatorAndThen(acc, cmp);
                  }
                }));
  }
}

exports.sortByToStr = sortByToStr;
exports.sortByFromStr = sortByFromStr;
exports.sortByGetTitle = sortByGetTitle;
exports.allSortByOptions = allSortByOptions;
exports.sortDirToStr = sortDirToStr;
exports.sortDirFromStr = sortDirFromStr;
exports.allSortDirOptions = allSortDirOptions;
exports.makeComparator = makeComparator;
/* Common Not a pure module */
